import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	form: {
		flexGrow: 1
	},
	resetButton: {
		marginTop: -theme.spacing(0.5),
		'&:focus': {
			boxShadow: ''
		}
	},
	calculateDesignsButton: {
		'&:focus': {
			boxShadow: ''
		},
		'& .MuiTypography-root': {
			fontWeight: 600
		}
	}
}));

export const useStylesChildren = makeStyles(theme => ({
	accordionContent: {
		marginTop: theme.spacing(1)
	},
	focusableTextField: {
		'& .MuiInputBase-root:focus': {
			boxShadow: ''
		}
	},
	focusableChipsLabel: {
		'& .MuiFormLabel-root:focus': {
			boxShadow: ''
		}
	},
	focusableChips: {
		cursor: 'pointer',
		'&:focus': {
			backgroundColor: ''
		}
	}
}));
